import packageJson from "../../../package.json";

export function VersionInfo() {
  return (
    <div
      style={{
        fontSize: 12,
        color: "#888",
        textAlign: "center",
      }}
    >
      Versão: {packageJson.version}
    </div>
  );
}
